import { Component, OnInit, EventEmitter } from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-event-cell-viewer',
  templateUrl: './event-cell-viewer.component.html',
  styleUrls: ['./event-cell-viewer.component.scss']
})
export class EventCellViewerComponent implements OnInit, CellComponent {
  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  displayText: string;
  value: any;
  disabled: boolean;

  constructor() { }

  ngOnInit() {
  }

}
